import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { hideModal } from "../../../store/slice/modalSlice";
import { useDispatch } from "react-redux";

interface PropType {
  isOpen: boolean;
}

export default function BrowserCompatibilityInfo(props: PropType) {
  const { isOpen } = props;
  const dispatch = useDispatch();
  return (
    <Dialog
      open={isOpen}
      onClose={() => dispatch(hideModal())}
      maxWidth={false}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          //   minWidth: { xs: "100%", sm: "400px", md: "550px", lg: "900px" },
          width: "400px",
        }}
      >
        <div>
          <Typography variant="h6" fontWeight={"600"} fontFamily="Lora">
            Browser Compatibility
          </Typography>
        </div>
        <div>
          <IconButton onClick={() => dispatch(hideModal())}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent sx={{ mt: "10px" }}>
        <Typography>
          1. Microsoft Edge <span style={{ color: "blue" }}>104+</span>
        </Typography>

        <Typography>
          2. Mozilla Firefox <span style={{ color: "blue" }}>91+</span>
        </Typography>

        <Typography>
          3. Google Chrome <span style={{ color: "blue" }}>104+</span>
        </Typography>

        <Typography>
          4. Safari <span style={{ color: "blue" }}>15+</span>
        </Typography>

        {/* <Stack direction={"row"} gap={1} mt={"20px"}>
          <Button
            variant="contained"
            sx={{ minWidth: 100 }}
            onClick={() => dispatch(hideModal())}
          >
            OK
          </Button>
          <Button
            sx={{ minWidth: 150, color: "#111928" }}
            onClick={() => dispatch(hideModal())}
          >
            Cancel
          </Button>
        </Stack> */}
      </DialogContent>
    </Dialog>
  );
}
